import { Routes, Route } from 'react-router-dom';
import { Login } from './pages/Login';
import './App.css';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import { TaskContextProvider } from './context/TaskContext';
import { Toaster } from 'sonner';
import { ProjectProvider } from './context/ProjectContext';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';

function App() {
  return (
    <div className="App">
      {/* Toaster global de Sonner para notificaciones modernas */}
      <Toaster position="top-center" richColors closeButton />
      
      <AuthProvider>
        <ProjectProvider>
          <TaskContextProvider>
            <Routes>
              <Route 
                path='/' 
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                } 
              />
              <Route path='/login' element={<Login />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
          </TaskContextProvider>
        </ProjectProvider>
      </AuthProvider>
    </div>
  );
}

export default App;